import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import axios from 'axios';

@Component({
  selector: 'app-docfertilizer',
  templateUrl: './docfertilizer.component.html',
  styleUrls: ['./docfertilizer.component.css']
})
export class DocfertilizerComponent implements OnInit {

  constructor(private route: ActivatedRoute) {
    this.Nowdate();
  }
  today: any;
  year: any;
  fmcode: any;
  docid: any;
  status: any;
  ngOnInit(): void {
    this.year = this.route.snapshot.paramMap.get('year');
    this.fmcode = this.route.snapshot.paramMap.get('fmcode');
    this.docid = this.route.snapshot.paramMap.get('doc_id');
    this.status = this.route.snapshot.paramMap.get('status');

    console.log('paramMap:', this.route.snapshot.paramMap);

    setTimeout(() => {
      this.Loaddatafarmer();
      this.Loadinforfarmer();
    }, 100);
  }

  alldata = [];
  cash_list = [];
  Loaddatafarmer() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfactor]&w=[YearID]='" + this.year + "' and fmcode_b1='" + this.fmcode + "'";
    axios.get(url).then(res => {
      let data = res.data;
      data.sort(function (a, b) { return b.docid - a.docid });
      if (this.status == 1) {
        this.alldata = (data)//.filter(el => el.docid == this.docid);
      }
      else if (this.status == 0) {
        this.alldata = (data).filter(el => el.doc_print == '0');
      }
      this.cash_list = (this.alldata).filter(el => el.take_method == 1);
      console.log('alldata', this.alldata);
      this.sumall();
      if (this.alldata.length > 0) {
        setTimeout(() => {
          window.print();
        }, 2000);
      }
    }).catch(err => { throw (err) })
  }
  one = {
    cemecal: 0,
    dolomite: 0,
    fertilizer: 0,
    oganic: 0,
    machin: 0,
  }

  sumall() {
    let data = this.alldata;
    this.one = {
      cemecal: (data.map(el => { return el.amt1 })).reduce((a, b) => a + b, 0),
      oganic: (data.map(el => { return el.amt2 })).reduce((a, b) => a + b, 0),
      fertilizer: (data.map(el => { return el.amt3 })).reduce((a, b) => a + b, 0),
      dolomite: (data.map(el => { return el.amt4 })).reduce((a, b) => a + b, 0),
      machin: (data.map(el => { return el.amt5 })).reduce((a, b) => a + b, 0)
    }
  }

  categoryNames = ['ขอเบิกปุ๋ยเคมี', 'ขอเบิกปุ๋ยอินทรีย์', 'ขอเบิกยาปราบศัตรูพืช', 'ขอเบิกโดโลไมท์', 'ขอเบิกอุปกรณ์'];
  onedata: any;
  Loadinforfarmer() {
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/v_farmer_basic_w?fmcode_b1='" + this.fmcode + "'")
      .then(res => {
        this.onedata = (res.data.recordset).slice(0, 1);
      }).catch(err => { throw (err) })
  }

  remove_val(docid = '') {
    this.alldata = this.alldata.filter(el => el.docid != docid);
    this.sumall();
  }

  Nowdate() {
    const date = new Date()
    const result = date.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    })
    this.today = result;
  }
}
